import React from 'react';
import { Box, Flex, DeprecatedIcon, Typography } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';

type NoResultsStateProps = {
  size: 'small' | 'large';
  inverse?: boolean;
  column?: boolean;
};

export const NoResultsState: React.FC<NoResultsStateProps> = ({
  size,
  inverse = false,
  column = false,
}) => {
  const isLarge = size === 'large';
  const iconColor = inverse ? 'neutrals-n0' : 'neutrals-n6';
  const textColor = inverse ? 'neutrals-n0' : 'neutrals-n10';

  return (
    <Box data-component="NoResultsState" padding={isLarge ? [20, 0, 20, 0] : 0}>
      <Flex column={isLarge || column} justifyContent={isLarge || column ? 'center' : 'flex-start'}>
        <DeprecatedIcon name="not-allowed" color={iconColor} size={isLarge ? 80 : 32} />
        {isLarge && (
          <Box padding={[32, 0, 16, 0]}>
            <Typography variant="heading3" color={textColor}>
              <FormattedMessage defaultMessage="No results" id="jHJmjf" />
            </Typography>
          </Box>
        )}
        <Box paddingLeft={isLarge ? 0 : 8}>
          <Typography variant={isLarge ? 'body2' : 'body4'} color={textColor}>
            <FormattedMessage defaultMessage="This query has no results." id="nvh5nq" />
          </Typography>
        </Box>
      </Flex>
    </Box>
  );
};
